/**
 * Resolve the correct backend URL prefix at runtime.
 *
 * Why this exists:
 *   The Emergent deploy bakes REACT_APP_BACKEND_URL into the JS bundle at
 *   build time (e.g. `https://travelai-vercel.emergent.host`). But once the
 *   user visits a CUSTOM DOMAIN like `travelaibg.com`, hitting the baked-in
 *   `*.emergent.host` URL is a cross-origin call — browsers block the
 *   auth cookie (SameSite + cross-origin), so login fails silently.
 *
 *   The fix is to detect production and use a SAME-ORIGIN empty prefix so
 *   `/api/...` calls hit whatever host the user is on. In local dev the
 *   frontend runs on :3000 and the backend on :8001, so we still need the
 *   absolute REACT_APP_BACKEND_URL there.
 */
const RAW = process.env.REACT_APP_BACKEND_URL || '';

function isLocalDev() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h.endsWith('.local');
}

/**
 * Returns:
 *   - '' (empty) in production / on any deployed host → triggers same-origin
 *     `/api/...` requests so cookies stay on the correct domain.
 *   - The full REACT_APP_BACKEND_URL during local dev (frontend:3000 → backend:8001).
 */
export function getApiBase() {
  if (isLocalDev()) return RAW;
  return '';
}

// Convenience constant for the common pattern `${API_URL}/api/...`.
export const API_URL = getApiBase();

export default API_URL;
